var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAddMusic = function SvgAddMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#393F4F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2 8.5c-1.7-1.3-4.2-1.6-7.3-.8L32 12.2c-3.6.9-5.8 3.8-5.8 7.4v28.8c-1.7-2.5-4.5-4.2-7.8-4.2-5.1 0-9.2 4.1-9.2 9.2s4.1 9.2 9.2 9.2 9.2-4.1 9.2-9.2V53 28.6L57.2 21v3c0 .4.3.8.8.8s.8-.3.8-.8v-8.9c0-3.1-.9-5.3-2.6-6.6zM18.5 61.2c-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8 7.8 3.5 7.8 7.8-3.5 7.8-7.8 7.8zM27.8 27v-7.4c0-2.9 1.7-5.2 4.6-5.9l16.9-4.5c1.8-.5 4.3-.8 6 .5 1.3 1 2 2.8 2 5.4v4.3L27.8 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 34.3c-.4 0-.8.3-.8.8v7.5c-1.7-2.5-4.5-4.2-7.8-4.2-5.1 0-9.2 4.1-9.2 9.2s4.1 9.2 9.2 9.2 9.2-4.1 9.2-9.2v-.4V35c.2-.4-.2-.7-.6-.7zm-8.5 20.9c-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8 7.8 3.5 7.8 7.8-3.5 7.8-7.8 7.8z"
  }))));
};
export default SvgAddMusic;